import { normalizeSignupIntent } from "@tennis-matches/services/auth";

const STORAGE_KEY = "ttb_register_wizard_draft_v1";
const MAX_AGE_MS = 1000 * 60 * 60 * 4;

function __asStr(v) {
  return String(v ?? "").trim();
}

/**
 * @param {object} draft
 */
export function saveRegisterWizardDraft(draft) {
  try {
    const payload = {
      savedAt: Date.now(),
      authMode: "register",
      regEmail: __asStr(draft?.regEmail),
      regFirstName: __asStr(draft?.regFirstName),
      regLastName: __asStr(draft?.regLastName),
      regSignupIntent: normalizeSignupIntent(draft?.regSignupIntent) || "",
      regScopeId: __asStr(draft?.regScopeId),
      regSelectedClub: draft?.regSelectedClub ?? null,
      regNewClubRequest: draft?.regNewClubRequest ?? null,
      regIndependent: Boolean(draft?.regIndependent),
      regRoles: Array.isArray(draft?.regRoles)
        ? draft.regRoles.map((r) => __asStr(r).toLowerCase()).filter(Boolean)
        : [],
      regWizardStep:
        Number(draft?.regWizardStep) > 0 ? Number(draft.regWizardStep) : 1,
      regConsentPrivacy: Boolean(draft?.regConsentPrivacy),
      regConsentTerms: Boolean(draft?.regConsentTerms),
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    /* ignore quota / private mode */
  }
}

/** @returns {ReturnType<typeof saveRegisterWizardDraft> extends void ? never : object|null} */
export function loadRegisterWizardDraft() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || typeof data !== "object" || data.authMode !== "register")
      return null;
    const age = Date.now() - Number(data.savedAt || 0);
    if (!Number.isFinite(age) || age > MAX_AGE_MS) {
      clearRegisterWizardDraft();
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function clearRegisterWizardDraft() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
